import React, { useEffect, useState, useRef } from 'react';
function AnimatedCounter({
  end,
  suffix
}: {
  end: number;
  suffix: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        let start = 0;
        const duration = 2000; // 2 seconds
        const increment = end / (duration / 16);
        const timer = setInterval(() => {
          start += increment;
          if (start >= end) {
            setCount(end);
            clearInterval(timer);
          } else {
            setCount(Math.floor(start));
          }
        }, 16);
        observer.disconnect();
      }
    }, {
      threshold: 0.5
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, [end]);
  return <div ref={ref} className="text-3xl md:text-5xl font-bold text-brand-red mb-2" data-id="element-13">
      {count}
      {suffix}
    </div>;
}
export function AboutSection() {
  return <section id="about" className="py-16 md:py-24 px-6 bg-light-gray" data-id="element-14">
      <div className="container mx-auto max-w-7xl" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-16">
          {/* Left: Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[280px] md:h-[400px] lg:h-[600px]" data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/ookoKgVh6nWoQzfg6CKfMd/Frame-1948755006.png" alt="Redline Pool Tile team at work" className="absolute inset-0 w-full h-full object-cover" data-id="element-18" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/60 to-transparent" data-id="element-19" />
          </div>

          {/* Right: Content */}
          <div className="flex flex-col" data-id="element-20">
            <span className="text-brand-red uppercase text-sm font-bold tracking-wider mb-3" data-id="element-21">
              About Us
            </span>
            <h2 className="text-charcoal text-3xl md:text-4xl font-bold uppercase tracking-wide mb-6" data-id="element-22">
              Arizona's Trusted Pool Tile Experts
            </h2>

            <p className="text-gray-700 text-lg leading-relaxed mb-10" data-id="element-23">
              At Redline Pool Tile, we're passionate about restoring the beauty
              and functionality of your pool. As a first-responder-owned
              company, we bring the same dedication, discipline, and reliability
              to every job. With years of experience specializing in calcium
              removal, acid washes, chlorine washes, and full drain-and-fills,
              we ensure your pool stays sparkling and inviting all year long.
            </p>

            {/* Stats Row */}
            <div className="grid grid-cols-3 gap-3 md:gap-6 mb-10 border-y border-gray-200 py-6 md:py-8" data-id="element-24">
              <div className="text-center" data-id="element-25">
                <AnimatedCounter end={100} suffix="%" data-id="element-26" />
                <div className="text-sm md:text-base text-gray-600 font-medium uppercase tracking-wide" data-id="element-27">
                  Client Satisfaction
                </div>
              </div>
              <div className="text-center border-x border-gray-200 px-2" data-id="element-28">
                <AnimatedCounter end={150} suffix="+" data-id="element-29" />
                <div className="text-sm md:text-base text-gray-600 font-medium uppercase tracking-wide" data-id="element-30">
                  Completed Projects
                </div>
              </div>
              <div className="text-center" data-id="element-31">
                <AnimatedCounter end={5} suffix="+" data-id="element-32" />
                <div className="text-sm md:text-base text-gray-600 font-medium uppercase tracking-wide" data-id="element-33">
                  Years of Experience
                </div>
              </div>
            </div>

            <a href="#contact" className="bg-brand-red hover:bg-brand-red-dark text-white rounded-lg px-8 py-4 text-lg font-bold transition-all duration-300 w-full sm:w-auto text-center self-start" data-id="element-34">
              Get a Free Quote
            </a>
          </div>
        </div>
      </div>
    </section>;
}